/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetProductSheetGroupForProductPageQueryResponse,
  GetProductSheetGroupForProductPagePathParams,
} from "../types/GetProductSheetGroupForProductPage.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getProductSheetGroupForProductPageQueryKey = (
  productSheetGroupId: GetProductSheetGroupForProductPagePathParams["productSheetGroupId"]
) =>
  [
    {
      url: "/v1/public/get-product-sheet-group-for-product-page/:productSheetGroupId",
      params: { productSheetGroupId: productSheetGroupId },
    },
  ] as const

export type GetProductSheetGroupForProductPageQueryKey = ReturnType<
  typeof getProductSheetGroupForProductPageQueryKey
>

/**
 * @summary Get product sheet group for product page
 * {@link /v1/public/get-product-sheet-group-for-product-page/:productSheetGroupId}
 */
export async function getProductSheetGroupForProductPage(
  productSheetGroupId: GetProductSheetGroupForProductPagePathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetProductSheetGroupForProductPageQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/public/get-product-sheet-group-for-product-page/${productSheetGroupId}`,
    ...requestConfig,
  })
  return res
}

export function getProductSheetGroupForProductPageQueryOptions(
  productSheetGroupId: GetProductSheetGroupForProductPagePathParams["productSheetGroupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey =
    getProductSheetGroupForProductPageQueryKey(productSheetGroupId)
  return queryOptions<
    ResponseConfig<GetProductSheetGroupForProductPageQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetProductSheetGroupForProductPageQueryResponse>,
    typeof queryKey
  >({
    enabled: !!productSheetGroupId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getProductSheetGroupForProductPage(productSheetGroupId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get product sheet group for product page
 * {@link /v1/public/get-product-sheet-group-for-product-page/:productSheetGroupId}
 */
export function useGetProductSheetGroupForProductPage<
  TData = ResponseConfig<GetProductSheetGroupForProductPageQueryResponse>,
  TQueryData = ResponseConfig<GetProductSheetGroupForProductPageQueryResponse>,
  TQueryKey extends QueryKey = GetProductSheetGroupForProductPageQueryKey,
>(
  productSheetGroupId: GetProductSheetGroupForProductPagePathParams["productSheetGroupId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetProductSheetGroupForProductPageQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getProductSheetGroupForProductPageQueryKey(productSheetGroupId)

  const query = useQuery(
    {
      ...getProductSheetGroupForProductPageQueryOptions(
        productSheetGroupId,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
